// $(document).ready(function(){
// 	$('.slider-for').slick({
// 	  slidesToShow: 1,
// 	  slidesToScroll: 1,
// 	  arrows: false,
// 	  fade: true,
// 	  asNavFor: '.product-thumbnail-slick'
// 	});
// 	$('.product-thumbnail-slick').slick({
// 		slidesToShow: 2,
// 		slidesToScroll: 1,
// 		vertical: true,
// 	   asNavFor: '.slider-for',
//        infinite:false,
// 	   centerMode: false,
// 	   focusOnSelect: true,
//        arrows:true
	
// 	});
// });
$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: false,
    asNavFor: '.product-thumbnail-slick',
     responsive: [
    {
        breakpoint: 992,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        infinite: false,
        dots:false
        }
    },
    {
      breakpoint: 768,
      settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: false,
      dots:false
      }
    },
    {
      breakpoint: 580,
      settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: false,
      dots:false
       
      }
    },
    {
      breakpoint: 380,
      settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: false,
      dots:false
       
      }
    }
    ]
});
$('.product-thumbnail-slick').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical:true,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true,
    arrows: true,
    infinite: false,
    responsive: [
    {
        breakpoint: 992,
        settings: {
          vertical: false,
        }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false,
      }
    },
    {
      breakpoint: 580,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 380,
      settings: {
        vertical: false,
        slidesToShow: 2,
      }
    }
    ]
});
 


//zoom functionality


// (function($){
//   "use strict";

//   var defaults = {
//     magnify: 1.8,
//     duration: 120,
//     on: 'mouseover', // options: 'mouseover', 'click', 'toggle', 'grab'
//     touch: true,
//     fancybox: true,
//     fancyboxOptions: {} // user can pass options here
//   };

//   function makeZoom(targetEl, sourceEl, hiResUrl, options) {
//     var target = targetEl;
//     var source = sourceEl;
//     var settings = options;
//     var img = document.createElement('img');
//     var img2 = img.cloneNode(false);
//     var $img = $(img);
//     var $img2 = $(img2);
//     var $target = $(target);
//     var $source = $(source);
//     var targetW, targetH, sourceW, sourceH, xRatio, yRatio, offset;
//     var started = false;
//     var loaded = false;
//     var computeQueued = false;

//     img.setAttribute('role','presentation');
//     img.alt = '';
//     img.src = hiResUrl;

//     var position = $target.css('position');
//     if (!/(absolute|fixed)/.test(position)) {
//       target.style.position = 'relative';
//     }
//     target.style.overflow = 'hidden';

//     $img.add($img2).addClass('zoomImg').css({
//       position: 'absolute',
//       top: 0, left: 0, opacity: 0,
//       border: 'none', maxWidth: 'none', maxHeight: 'none', pointerEvents: 'none'
//     });

//     $target.append($img);
//     $target.append($img2);

//     function ensureLoaded(cb) {
//       if (loaded) return cb();
//       if (img.complete && (img.naturalWidth || img.width)) {
//         loaded = true;
//         return cb();
//       }
//       $img.on('load.zoomReady', function () {
//         if (!loaded) { loaded = true; $img.off('load.zoomReady'); cb(); }
//       });
//       img.onload = function(){
//         if (!loaded) { loaded = true; $img.off('load.zoomReady'); cb(); }
//       };
//       setTimeout(function(){
//         if (!loaded && img.complete && (img.naturalWidth || img.width)) {
//           loaded = true;
//           $img.off('load.zoomReady');
//           cb();
//         }
//       }, 50);
//     }

//     function compute() {
//       targetW = $target.outerWidth();
//       targetH = $target.outerHeight();

//       sourceW = $source.outerWidth();
//       sourceH = $source.outerHeight();

//       var naturalW = img.naturalWidth || img.width || $img.width();
//       var naturalH = img.naturalHeight || img.height || $img.height();

//       if (!naturalW) naturalW = Math.max(targetW, sourceW);
//       if (!naturalH) naturalH = Math.max(targetH, sourceH);

//       var displayW = naturalW * settings.magnify;
//       var displayH = naturalH * settings.magnify;

//       $img.css({ width: displayW + 'px', height: displayH + 'px' });
//       $img2.css({ width: displayW + 'px', height: displayH + 'px' });

//       xRatio = (displayW - targetW) / (sourceW || targetW);
//       yRatio = (displayH - targetH) / (sourceH || targetH);

//       offset = $source.offset() || { left: 0, top: 0 };
//       computeQueued = false;
//     }

//     function scheduleCompute() {
//       if (computeQueued) return;
//       computeQueued = true;
//       ensureLoaded(function(){ compute(); });
//     }

//     function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

//     function move(e){
//       if (!offset) {
//         scheduleCompute();
//         return;
//       }

//       var pageX = e.pageX, pageY = e.pageY;
//       if (e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0]) {
//         pageX = e.originalEvent.touches[0].pageX;
//         pageY = e.originalEvent.touches[0].pageY;
//       }
//       var left = (pageX - offset.left);
//       var top  = (pageY - offset.top);

//       left = clamp(left, 0, sourceW);
//       top  = clamp(top, 0, sourceH);

//       var leftPx = (left * -xRatio) + 'px';
//       var topPx  = (top * -yRatio) + 'px';

//       img.style.left = leftPx; img.style.top = topPx;
//       img2.style.left = leftPx; img2.style.top = topPx;
//     }

//     function start(e){
//       ensureLoaded(function(){
//         if (!offset) compute();
//         if (!started) {
//           move(e);
//           $img.stop().fadeTo($.support.opacity ? settings.duration : 0, 1);
//           $img2.stop().fadeTo($.support.opacity ? settings.duration : 0, 1);
//           started = true;
//           $source.addClass('zoom-active');
//         } else {
//           move(e);
//         }
//       });
//     }

//     function stop(){
//       if (started) {
//         $img.stop().fadeTo(settings.duration, 0);
//         $img2.stop().fadeTo(settings.duration, 0);
//         started = false;
//         $source.removeClass('zoom-active');
//       }
//     }

//     function destroy(){
//       $img.off('.zoomReady').remove();
//       $img2.remove();
//       img.onload = null;
//     }

//     return {
//       init: scheduleCompute,
//       move: move,
//       start: start,
//       stop: stop,
//       destroy: destroy,
//       $img: $img,
//       $img2: $img2,
//       imgEl: img,
//       imgEl2: img2
//     };
//   }

//   $.fn.initGalleryZoom = function(opts){
//     var settings = $.extend({}, defaults, opts || {});
//     var $slick = this;
//     var currentZoom = null;
//     var currentZoomSource = null;

//     function getHighResUrlFromSlide($slide) {
//       var $img = $slide.find('img.product-single__photo').first();
//       if (!$img || !$img.length) return null;
//       var hi = $img.attr('data-zoom-img') || $img.attr('data-image-zoom') || $img.data('zoom-img') || $img.attr('data-src') || $img.attr('src') || ($img[0] && $img[0].currentSrc);
//       if (!hi) return null;
//       if (/^\/\//.test(hi)) hi = window.location.protocol + hi;
//       return hi;
//     }

//     // Build Fancybox gallery items (from slides). returns array of { src, opts } objects
//     function buildFancyItems($slides) {
//       var items = [];
//       $slides.each(function() {
//         var $s = $(this);
//         var hi = getHighResUrlFromSlide($s);
//         if (!hi) return;
//         var $img = $s.find('img.product-single__photo').first();
//         var caption = ($img && $img.length) ? ($img.attr('alt') || $img.attr('title') || '') : '';
//         items.push({ src: hi, opts: { caption: caption } });
//       });
//       return items;
//     }

//     function openInFancyboxGallery(startIndex, $slides) {
//       var items = buildFancyItems($slides);
//       if (!items.length) {
//         return;
//       }

//       // If fancybox exists, open as gallery. Otherwise open the single hi-res in new tab.
//       if (settings.fancybox && window.jQuery && jQuery.fancybox) {
//         try {
//           jQuery.fancybox.open(items, settings.fancyboxOptions || {}, startIndex || 0);
//           return;
//         } catch (err) {
//           // fallback below
//         }
//       }

//       // fallback: open the start image in a new tab
//       var start = items[startIndex] || items[0];
//       window.open(start.src, '_blank');
//     }

//     function destroyCurrent() {
//       if (currentZoom) {
//         $(currentZoomSource).off('.customZoom');
//         currentZoom.destroy();
//         currentZoom = null;
//         currentZoomSource = null;
//       }
//     }

//     function attachZoomToSlide($slide) {
//       destroyCurrent();
//       if (!$slide || !$slide.length) return;

//       var $source = $slide.find('.product-single__media__image').first();
//       if (!$source || !$source.length) return;

//       var hiRes = getHighResUrlFromSlide($slide);
//       if (!hiRes) return;

//       var zoom = makeZoom($source[0], $source[0], hiRes, settings);
//       currentZoom = zoom;
//       currentZoomSource = $source[0];

//       // Wire the zoom interactions (preserve user's chosen mode)
//       if (settings.on === 'grab') {
//         $($source).on('mousedown.customZoom', function(e){
//           if (e.which !== 1) return;
//           zoom.start(e);
//           $(document).one('mouseup.customZoom', function(){ zoom.stop(); });
//           $(document).on('mousemove.customZoom', zoom.move);
//           e.preventDefault();
//         });
//       } else if (settings.on === 'click') {
//         $($source).on('click.customZoom', function(e){
//           if (zoom._clicked) {
//             zoom.stop(); zoom._clicked = false; $(document).off('mousemove.customZoom', zoom.move);
//           } else {
//             zoom.start(e); zoom._clicked = true; $(document).on('mousemove.customZoom', zoom.move);
//             $(document).one('click.customZoom', function(){ zoom.stop(); zoom._clicked = false; $(document).off('mousemove.customZoom', zoom.move); });
//           }
//           e.preventDefault();
//         });
//       } else if (settings.on === 'toggle') {
//         $($source).on('click.customZoom', function(e){
//           if (zoom._toggled) { zoom.stop(); zoom._toggled = false; } else { zoom.start(e); zoom._toggled = true; }
//         });
//       } else {
//         $($source).on('mouseenter.customZoom', function(e){ zoom.start(e); })
//                   .on('mouseleave.customZoom', function(){ zoom.stop(); })
//                   .on('mousemove.customZoom', function(e){ zoom.move(e); });
//       }

//       if (settings.touch) {
//         $($source)
//           .on('touchstart.customZoom', function(e){
//             e.preventDefault();
//             if (zoom._touched) { zoom._touched = false; zoom.stop(); }
//             else { zoom._touched = true; zoom.start(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]); }
//           })
//           .on('touchmove.customZoom', function(e){
//             e.preventDefault();
//             zoom.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]);
//           })
//           .on('touchend.customZoom', function(e){
//             e.preventDefault();
//             if (zoom._touched) { zoom._touched = false; zoom.stop(); }
//           });
//       }

//       // SINGLE-CLICK to open Fancybox gallery:
//       // clicking the visible slide will open the gallery (all slides) at the clicked slide's index.
//       // This won't stop hover-zoom (if on === 'mouseover') — we still allow both.
//       $($source).on('click.openFancybox', function(e){
//         // Prevent double reaction if zoom is using click mode, but user explicitly requested click-to-open:
//         // For click-mode zoom we still let click open the gallery (user asked for click); if you want different behavior, tell me.
//         e.preventDefault();

//         // Find all slides (use slick instance if available)
//         var slickInst = $slick.data('slick') || ($slick[0] && $slick[0].slick);
//         var $slides;
//         if (slickInst && slickInst.$slides) {
//           $slides = $(slickInst.$slides);
//         } else {
//           $slides = $slick.find('.slick-slide');
//         }

//         // Determine start index using data-slick-index or the position in $slides
//         var startIndex = 0;
//         var ds = $slide.attr('data-slick-index');
//         if (typeof ds !== 'undefined') {
//           // find the index among slides that have hi-res items (we'll count)
//           var idxStr = ds.toString();
//           // Build array of slides preserving order in $slides and find index by data-slick-index match
//           var arr = [];
//           $slides.each(function(i, el){
//             var $s = $(el);
//             var hi = getHighResUrlFromSlide($s);
//             if (hi) arr.push({ el: $s, ds: $s.attr('data-slick-index') });
//           });
//           for (var k = 0; k < arr.length; k++) {
//             if (arr[k].ds == idxStr) { startIndex = k; break; }
//           }
//         } else {
//           // fallback: find index by element position
//           var allItems = buildFancyItems($slides);
//           // find first matching src equal to hiRes
//           var itemsSrcs = allItems.map(function(i){ return i.src; });
//           startIndex = itemsSrcs.indexOf(hiRes);
//           if (startIndex < 0) startIndex = 0;
//         }

//         // Open gallery
//         openInFancyboxGallery(startIndex, $slides);
//       });

//       // init compute
//       zoom.init();
//       $(window).on('resize.customZoom', function(){ zoom.init(); });
//     }

//     function handleSlideChange(e, slick, currentSlide){
//       var idx = 0;
//       if (typeof currentSlide === 'number') idx = currentSlide;
//       else if (slick && slick.currentSlide !== undefined) idx = slick.currentSlide;
//       else {
//         var $cur = $slick.find('.slick-slide.slick-current').first();
//         if ($cur.length) {
//           var ds = $cur.attr('data-slick-index');
//           if (ds !== undefined) idx = parseInt(ds,10);
//         }
//       }

//       var $slides = (slick && slick.$slides) ? $(slick.$slides) : $slick.find('.slick-slide');
//       var $curSlide = $slides.filter('[data-slick-index="'+idx+'"]').first();
//       if (!$curSlide.length) $curSlide = $slides.filter('.slick-current').first();
//       if (!$curSlide.length && $slides.length) $curSlide = $slides.first();

//       attachZoomToSlide($curSlide);
//     }

//     $slick.on('init.zGallery afterChange.zGallery', handleSlideChange);

//     function tryImmediateAttach() {
//       var slickInst = $slick.data('slick') || ($slick[0] && $slick[0].slick);
//       if (slickInst && typeof slickInst.currentSlide !== 'undefined') {
//         var idx = slickInst.currentSlide;
//         var $slides = $(slickInst.$slides || $slick.find('.slick-slide'));
//         var $cur = $slides.filter('[data-slick-index="'+idx+'"]').first();
//         if (!$cur.length) $cur = $slides.filter('.slick-current').first();
//         if (!$cur.length) $cur = $slides.first();
//         attachZoomToSlide($cur);
//         return;
//       }

//       var $foundCur = $slick.find('.slick-slide.slick-current').first();
//       if ($foundCur.length) { attachZoomToSlide($foundCur); return; }

//       var $slides = $slick.find('.slick-slide');
//       if ($slides.length) { attachZoomToSlide($slides.first()); return; }

//       var $candidate = $slick.find('.product-single__media__image').first();
//       if ($candidate.length) { attachZoomToSlide($candidate.closest('.slick-slide').length ? $candidate.closest('.slick-slide') : $candidate); }
//     }

//     setTimeout(tryImmediateAttach, 0);
//     $(window).on('load.initGalleryZoom', function(){ tryImmediateAttach(); });

//     // helper: build fancy items used above (exposed inside closure)
//     function buildFancyItems($slides) {
//       var items = [];
//       $slides.each(function() {
//         var $s = $(this);
//         var hi = getHighResUrlFromSlide($s);
//         if (!hi) return;
//         var $img = $s.find('img.product-single__photo').first();
//         var caption = ($img && $img.length) ? ($img.attr('alt') || $img.attr('title') || '') : '';
//         items.push({ src: hi, opts: { caption: caption } });
//       });
//       return items;
//     }

//     function openInFancyboxGallery(startIndex, $slides) {
//       var items = buildFancyItems($slides);
//       if (!items.length) return;
//       if (settings.fancybox && window.jQuery && jQuery.fancybox) {
//         try {
//           jQuery.fancybox.open(items, settings.fancyboxOptions || {}, startIndex || 0);
//           return;
//         } catch (err) {
//           // fallback below
//         }
//       }
//       var start = items[startIndex] || items[0];
//       window.open(start.src, '_blank');
//     }

//     return {
//       attachTo: function($slide){ attachZoomToSlide($slide); },
//       destroyCurrent: function(){ destroyCurrent(); $(window).off('resize.customZoom'); }
//     };
//   };

// })(jQuery);

// /* ---------------------------
//   Usage example:
// ---------------------------- */
// $(document).ready(function(){
//   var $gallery = $('.slider-for');
//   $gallery.initGalleryZoom({
//     magnify: 1,
//     on: 'mouseover',
//     duration: 120,
//     touch: true,
//     fancybox: true,
//     fancyboxOptions: {
//       loop: true,
//       buttons: ["zoom","slideShow","close"]
//     }
//   });
// });


(function($){
  "use strict";

  var defaults = {
    magnify: 1.8,
    duration: 120,
    on: 'mouseover', // options: 'mouseover', 'click', 'toggle', 'grab'
    touch: true,
    fancybox: true,
    fancyboxOptions: {} // user can pass options here
  };

  // Lock to prevent immediate re-open when closing Fancybox
  var fancyLock = false;

  function makeZoom(targetEl, sourceEl, hiResUrl, options) {
    var target = targetEl;
    var source = sourceEl;
    var settings = options;
    var img = document.createElement('img');
    var img2 = img.cloneNode(false);
    var $img = $(img);
    var $img2 = $(img2);
    var $target = $(target);
    var $source = $(source);
    var targetW, targetH, sourceW, sourceH, xRatio, yRatio, offset;
    var started = false;
    var loaded = false;
    var computeQueued = false;

    img.setAttribute('role','presentation');
    img.alt = '';
    img.src = hiResUrl;

    var position = $target.css('position');
    if (!/(absolute|fixed)/.test(position)) {
      target.style.position = 'relative';
    }
    target.style.overflow = 'hidden';

    $img.add($img2).addClass('zoomImg').css({
      position: 'absolute',
      top: 0, left: 0, opacity: 0,
      border: 'none', maxWidth: 'none', maxHeight: 'none', pointerEvents: 'none'
    });

    $target.append($img);
    $target.append($img2);

    function ensureLoaded(cb) {
      if (loaded) return cb();
      if (img.complete && (img.naturalWidth || img.width)) {
        loaded = true;
        return cb();
      }
      $img.on('load.zoomReady', function () {
        if (!loaded) { loaded = true; $img.off('load.zoomReady'); cb(); }
      });
      img.onload = function(){
        if (!loaded) { loaded = true; $img.off('load.zoomReady'); cb(); }
      };
      setTimeout(function(){
        if (!loaded && img.complete && (img.naturalWidth || img.width)) {
          loaded = true;
          $img.off('load.zoomReady');
          cb();
        }
      }, 50);
    }

    function compute() {
      targetW = $target.outerWidth();
      targetH = $target.outerHeight();

      sourceW = $source.outerWidth();
      sourceH = $source.outerHeight();

      var naturalW = img.naturalWidth || img.width || $img.width();
      var naturalH = img.naturalHeight || img.height || $img.height();

      if (!naturalW) naturalW = Math.max(targetW, sourceW);
      if (!naturalH) naturalH = Math.max(targetH, sourceH);

      var displayW = naturalW * settings.magnify;
      var displayH = naturalH * settings.magnify;

      $img.css({ width: displayW + 'px', height: displayH + 'px' });
      $img2.css({ width: displayW + 'px', height: displayH + 'px' });

      xRatio = (displayW - targetW) / (sourceW || targetW);
      yRatio = (displayH - targetH) / (sourceH || targetH);

      offset = $source.offset() || { left: 0, top: 0 };
      computeQueued = false;
    }

    function scheduleCompute() {
      if (computeQueued) return;
      computeQueued = true;
      ensureLoaded(function(){ compute(); });
    }

    function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

    function move(e){
      if (!offset) {
        scheduleCompute();
        return;
      }

      var pageX = e.pageX, pageY = e.pageY;
      if (e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0]) {
        pageX = e.originalEvent.touches[0].pageX;
        pageY = e.originalEvent.touches[0].pageY;
      }
      var left = (pageX - offset.left);
      var top  = (pageY - offset.top);

      left = clamp(left, 0, sourceW);
      top  = clamp(top, 0, sourceH);

      var leftPx = (left * -xRatio) + 'px';
      var topPx  = (top * -yRatio) + 'px';

      img.style.left = leftPx; img.style.top = topPx;
      img2.style.left = leftPx; img2.style.top = topPx;
    }

    function start(e){
      ensureLoaded(function(){
        if (!offset) compute();
        if (!started) {
          move(e);
          $img.stop().fadeTo($.support.opacity ? settings.duration : 0, 1);
          $img2.stop().fadeTo($.support.opacity ? settings.duration : 0, 1);
          started = true;
          $source.addClass('zoom-active');
        } else {
          move(e);
        }
      });
    }

    function stop(){
      if (started) {
        $img.stop().fadeTo(settings.duration, 0);
        $img2.stop().fadeTo(settings.duration, 0);
        started = false;
        $source.removeClass('zoom-active');
      }
    }

    function destroy(){
      $img.off('.zoomReady').remove();
      $img2.remove();
      img.onload = null;
    }

    return {
      init: scheduleCompute,
      move: move,
      start: start,
      stop: stop,
      destroy: destroy,
      $img: $img,
      $img2: $img2,
      imgEl: img,
      imgEl2: img2
    };
  }

  $.fn.initGalleryZoom = function(opts){
    var settings = $.extend({}, defaults, opts || {});
    var $slick = this;
    var currentZoom = null;
    var currentZoomSource = null;

    function getHighResUrlFromSlide($slide) {
      var $img = $slide.find('img.product-single__photo').first();
      if (!$img || !$img.length) return null;
      var hi = $img.attr('data-zoom-img') || $img.attr('data-image-zoom') || $img.data('zoom-img') || $img.attr('data-src') || $img.attr('src') || ($img[0] && $img[0].currentSrc);
      if (!hi) return null;
      if (/^\/\//.test(hi)) hi = window.location.protocol + hi;
      return hi;
    }

    function buildFancyItems($slides) {
      var items = [];
      $slides.each(function() {
        var $s = $(this);
        var hi = getHighResUrlFromSlide($s);
        if (!hi) return;
        var $img = $s.find('img.product-single__photo').first();
        var caption = ($img && $img.length) ? ($img.attr('alt') || $img.attr('title') || '') : '';
        items.push({ src: hi, opts: { caption: caption } });
      });
      return items;
    }

    function openInFancyboxGallery(startIndex, $slides) {
      var items = buildFancyItems($slides);
      if (!items.length) {
        return;
      }

      if (settings.fancybox && window.jQuery && jQuery.fancybox) {
        try {
          // merge user's options but ensure afterClose clears the lock
          var userOpts = settings.fancyboxOptions || {};
          var userAfterClose = userOpts.afterClose;
          var mergedOpts = $.extend(true, {}, userOpts, {
            afterClose: function(instance, slide) {
              // clear the lock
              fancyLock = false;
              // call user afterClose if they provided one
              if ($.isFunction(userAfterClose)) {
                try { userAfterClose.apply(this, arguments); } catch (err) { /* swallow user afterClose errors */ }
              }
            }
          });
          // open with merged options
          jQuery.fancybox.open(items, mergedOpts, startIndex || 0);
          return;
        } catch (err) {
          // fallback below
        }
      }

      // fallback: open the start image in a new tab and clear lock soon
      var start = items[startIndex] || items[0];
      window.open(start.src, '_blank');
      setTimeout(function(){ fancyLock = false; }, 300);
    }

    function destroyCurrent() {
      if (currentZoom) {
        $(currentZoomSource).off('.customZoom');
        $(currentZoomSource).off('.openFancybox'); // remove openFancybox too
        currentZoom.destroy();
        currentZoom = null;
        currentZoomSource = null;
      }
    }

    function attachZoomToSlide($slide) {
      destroyCurrent();
      if (!$slide || !$slide.length) return;

      var $source = $slide.find('.product-single__media__image').first();
      if (!$source || !$source.length) return;

      var hiRes = getHighResUrlFromSlide($slide);
      if (!hiRes) return;

      var zoom = makeZoom($source[0], $source[0], hiRes, settings);
      currentZoom = zoom;
      currentZoomSource = $source[0];

      // Wire the zoom interactions (preserve user's chosen mode)
      if (settings.on === 'grab') {
        $($source).on('mousedown.customZoom', function(e){
          if (e.which !== 1) return;
          zoom.start(e);
          $(document).one('mouseup.customZoom', function(){ zoom.stop(); });
          $(document).on('mousemove.customZoom', zoom.move);
          e.preventDefault();
        });
      } else if (settings.on === 'click') {
        $($source).on('click.customZoom', function(e){
          if (zoom._clicked) {
            zoom.stop(); zoom._clicked = false; $(document).off('mousemove.customZoom', zoom.move);
          } else {
            zoom.start(e); zoom._clicked = true; $(document).on('mousemove.customZoom', zoom.move);
            $(document).one('click.customZoom', function(){ zoom.stop(); zoom._clicked = false; $(document).off('mousemove.customZoom', zoom.move); });
          }
          e.preventDefault();
        });
      } else if (settings.on === 'toggle') {
        $($source).on('click.customZoom', function(e){
          if (zoom._toggled) { zoom.stop(); zoom._toggled = false; } else { zoom.start(e); zoom._toggled = true; }
        });
      } else {
        $($source).on('mouseenter.customZoom', function(e){ zoom.start(e); })
                  .on('mouseleave.customZoom', function(){ zoom.stop(); })
                  .on('mousemove.customZoom', function(e){ zoom.move(e); });
      }

      if (settings.touch) {
        $($source)
          .on('touchstart.customZoom', function(e){
            e.preventDefault();
            if (zoom._touched) { zoom._touched = false; zoom.stop(); }
            else { zoom._touched = true; zoom.start(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]); }
          })
          .on('touchmove.customZoom', function(e){
            e.preventDefault();
            zoom.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]);
          })
          .on('touchend.customZoom', function(e){
            e.preventDefault();
            if (zoom._touched) { zoom._touched = false; zoom.stop(); }
          });
      }

      // SINGLE-CLICK to open Fancybox gallery:
      // Prevent immediate re-open on close by using fancyLock, stopPropagation, and clearing lock in afterClose
      $($source).off('click.openFancybox').on('click.openFancybox', function(e){
        // If locked, ignore click (prevents re-open right after close)
        if (fancyLock) {
          e.stopPropagation();
          e.preventDefault();
          return;
        }
        // set lock immediately so the click that opens Fancybox won't race with a close-click bubbling back
        fancyLock = true;
        // safety clear in 500ms in case afterClose isn't invoked for some reason
        setTimeout(function(){ fancyLock = false; }, 500);

        // prevent the click from bubbling to underlying elements (very important)
        e.stopPropagation();
        e.preventDefault();

        // Find slide collection
        var slickInst = $slick.data('slick') || ($slick[0] && $slick[0].slick);
        var $slides;
        if (slickInst && slickInst.$slides) {
          $slides = $(slickInst.$slides);
        } else {
          $slides = $slick.find('.slick-slide');
        }

        // Determine start index for gallery
        var startIndex = 0;
        var ds = $slide.attr('data-slick-index');
        if (typeof ds !== 'undefined') {
          var idxStr = ds.toString();
          var arr = [];
          $slides.each(function(i, el){
            var $s = $(el);
            var hi = getHighResUrlFromSlide($s);
            if (hi) arr.push({ el: $s, ds: $s.attr('data-slick-index') });
          });
          for (var k = 0; k < arr.length; k++) {
            if (arr[k].ds == idxStr) { startIndex = k; break; }
          }
        } else {
          var allItems = buildFancyItems($slides);
          var itemsSrcs = allItems.map(function(i){ return i.src; });
          startIndex = itemsSrcs.indexOf(hiRes);
          if (startIndex < 0) startIndex = 0;
        }

        openInFancyboxGallery(startIndex, $slides);
      });

      // init compute
      zoom.init();
      $(window).on('resize.customZoom', function(){ zoom.init(); });
    }

    function handleSlideChange(e, slick, currentSlide){
      var idx = 0;
      if (typeof currentSlide === 'number') idx = currentSlide;
      else if (slick && slick.currentSlide !== undefined) idx = slick.currentSlide;
      else {
        var $cur = $slick.find('.slick-slide.slick-current').first();
        if ($cur.length) {
          var ds = $cur.attr('data-slick-index');
          if (ds !== undefined) idx = parseInt(ds,10);
        }
      }

      var $slides = (slick && slick.$slides) ? $(slick.$slides) : $slick.find('.slick-slide');
      var $curSlide = $slides.filter('[data-slick-index="'+idx+'"]').first();
      if (!$curSlide.length) $curSlide = $slides.filter('.slick-current').first();
      if (!$curSlide.length && $slides.length) $curSlide = $slides.first();

      attachZoomToSlide($curSlide);
    }

    $slick.on('init.zGallery afterChange.zGallery', handleSlideChange);

    function tryImmediateAttach() {
      var slickInst = $slick.data('slick') || ($slick[0] && $slick[0].slick);
      if (slickInst && typeof slickInst.currentSlide !== 'undefined') {
        var idx = slickInst.currentSlide;
        var $slides = $(slickInst.$slides || $slick.find('.slick-slide'));
        var $cur = $slides.filter('[data-slick-index="'+idx+'"]').first();
        if (!$cur.length) $cur = $slides.filter('.slick-current').first();
        if (!$cur.length) $cur = $slides.first();
        attachZoomToSlide($cur);
        return;
      }

      var $foundCur = $slick.find('.slick-slide.slick-current').first();
      if ($foundCur.length) { attachZoomToSlide($foundCur); return; }

      var $slides = $slick.find('.slick-slide');
      if ($slides.length) { attachZoomToSlide($slides.first()); return; }

      var $candidate = $slick.find('.product-single__media__image').first();
      if ($candidate.length) { attachZoomToSlide($candidate.closest('.slick-slide').length ? $candidate.closest('.slick-slide') : $candidate); }
    }

    setTimeout(tryImmediateAttach, 0);
    $(window).on('load.initGalleryZoom', function(){ tryImmediateAttach(); });

    return {
      attachTo: function($slide){ attachZoomToSlide($slide); },
      destroyCurrent: function(){ destroyCurrent(); $(window).off('resize.customZoom'); }
    };
  };

})(jQuery);

/* ---------------------------
  Usage example:
---------------------------- */
$(document).ready(function(){
  var $gallery = $('.slider-for');
  $gallery.initGalleryZoom({
    magnify: 1,
    on: 'mouseover',
    duration: 120,
    touch: true,
    fancybox: true,
    fancyboxOptions: {
      loop: true,
      buttons: ["zoom","slideShow","close"]
    }
  });
});


// FORCE HOMEPAGE HERO HEIGHT
document.addEventListener('DOMContentLoaded', function () {
  var style = document.createElement('style');
  style.innerHTML = `
    .slick-slider,
    .slick-list {
      height: 700px !important;
      max-height: 700px !important;
    }

    @media (max-width: 768px) {
      .slick-slider,
      .slick-list {
        height: 420px !important;
        max-height: 420px !important;
      }
    }
  `;
  document.head.appendChild(style);
});
